export enum RegisterStatus {
  ADDED = 'ADDED',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  INVALID_USER_DATA = 'INVALID_USER_DATA',
  FAILED = 'FAILED',
}
